module.exports = __webpack_public_path__ + "img/consultants.04e78049.svg";